import { useCallback } from 'react';
import { t } from '@lingui/macro';
import styled from 'styled-components';

import Phone from '@decisiv/iconix/lib/components/Phone';

import Button, {
  ButtonProps,
} from '@decisiv/ui-components/lib/components/Button';
import { P } from '@decisiv/ui-components/lib/components/Typography';

interface ClickToCallButtonProps extends ButtonProps {
  phone?: string;
  name: string;
  withIcon?: boolean;
}

const NoPaddingButton = styled(Button)`
  padding: 0;
  justify-content: flex-start;
` as unknown as typeof Button;

/**
 * Given a phone number and a name, show a button which when clicked
 * will initiate a phone call to the given number via the native tel: protocol.
 * The name will only be used for the aria-label.
 */
export default function ClickToCallButton(props: ClickToCallButtonProps) {
  /* istanbul ignore next -- @preserve */
  const {
    phone = '',
    name,
    withIcon = true,
    variant = 'ghost',
    ...rest
  } = props;

  const handleClick = useCallback(() => {
    window.location.href = `tel:${phone}`;
  }, [phone]);

  /* istanbul ignore next -- @preserve */
  if (!phone) {
    return <P>-</P>;
  }

  const nameOrPhoneNumber = name || phone;

  return (
    <NoPaddingButton
      aria-label={t`Call ${nameOrPhoneNumber}`}
      onClick={handleClick}
      text={phone}
      icon={withIcon ? Phone : undefined}
      variant={variant}
      {...rest}
    />
  );
}
